import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../AxiosInstance";
import { useTranslation } from "react-i18next";
import { URLS } from "../../API/API endpoints";
import { Image } from "antd";
import { store } from "../../Redux/store";
import { routes } from "../../Routes";
import { useNavigate } from "react-router-dom";

// const width =
function Pricing() {
  const { i18n, t } = useTranslation();
  const [subscriptioPacks, setSubscriptioPacks] = useState([]);
  const [billing, setBilling] = useState("Yearly");
  const divRef = useRef(null);
  const { login } = store.getState();
  const user_id = login.user;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const navigate = useNavigate();
  useEffect(() => {
    GetSubscriptionPlans();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const GetSubscriptionPlans = async () => {
    try {
      const response = await axiosInstance.post(URLS.GET_SUBSCRIPTION_PLANS, {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });
      console.log("DATA===>", response?.data);

      if (response?.data?.result?.status === 200) {
        setSubscriptioPacks(response?.data?.result?.data);
      } else {
        setSubscriptioPacks([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
    }
  };
  useEffect(() => {
    if (divRef.current) {
      setWidth(divRef.current.getBoundingClientRect().width);
    }

    const handleResize = () => {
      if (divRef.current) {
        setWidth(divRef.current.getBoundingClientRect().width);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const parseDescription = (desc) =>
    desc
      .split("\n")
      .filter((line) => line.trim() !== "")
      .map((line) => line.replace("✅", "").trim());
  const [width, setWidth] = useState(0);

  const counts = subscriptioPacks.reduce((acc, item) => {
    acc[item.billing_type] = (acc[item.billing_type] || 0) + 1;
    return acc;
  }, {});

  const billingTypes = Array.from(
    new Set((subscriptioPacks || []).map((plan) => plan.billing_type)),
  );

  return (
    <div className="flex flex-col justify-between w-full px-4 items-center  py-8 md:py-16 scroll-mt-24 " style={{borderBottom:"2px gray-500"}} id="pricing">
        <div className="mx-auto mb-6 sm:mb-6 max-w-3xl text-center">
          <h2 className="mb-4 text-2xl sm:text-4xl font-extrabold tracking-normal leading-tight text-gray-900">
            {t("Plans & Pricing")}
          </h2>

          <p className="text-base sm:text-lg text-gray-600">
            {t(
              "Choose the perfect plan for your business"
            )}
          </p>
        </div>
      <div className="flex bg-gray-200 rounded-full p-1 mb-6">
        {[...billingTypes].reverse().map((type) => (
          <button
            key={type}
            onClick={() => setBilling(type)}
            className={`px-6 py-2 rounded-full font-medium transition ${
              billing === type ? "bg-gray-800 text-white" : "text-gray-600"
            }`}
          >
            {t(type)}
          </button>
        ))}
      </div>
      <div className="flex flex-col md:flex-row gap-4 min-w-max pb-2 justify-center">
        {subscriptioPacks
          ?.filter((plan) => plan.billing_type === billing)
          ?.map((plan, index) => {
            const benefits = plan.description
              ? parseDescription(plan.description)
              : [];

            return (
              <div
                key={plan.id}
                style={{
                  width: isMobile
                    ? "100%"
                    : counts[billing] === 4
                      ? "23%"
                      : counts[billing] === 3
                        ? "30%"
                        : counts[billing] === 2
                          ? "48%"
                          : "90%",
                }}
                className={`relative  rounded-2xl flex  items-end cursor-pointer bg-primaryBlue transition 
                                            border-2 border-white hover:border-2 hover:border-primaryBlue hover:shadow-lg ${
                                              plan.is_most_popular
                                                ? "bg-primaryBlue pt-2"
                                                : "bg-white"
                                            }`}
              >
                <div
                  className={`bg-white w-full p-6 h-[98%] rounded-t-2xl rounded-b-xl flex flex-col hover:bg-[#ECF3FF] ${
                    plan.is_most_popular ? "h-[98%]" : "h-full"
                  }`}
                >
                  {/* Tag */}
                  {plan.is_most_popular && (
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-2 text-xs font-semibold rounded-full bg-gradient-to-r from-[#F8C42B] to-[#F6A669] text-white">
                      {t("MOST POPULAR")}
                    </div>
                  )}

                  {/* Title */}
                  <h2 className="text-lg text-center font-bold mb-2 mt-6 uppercase">
                    {t(plan.plan_name)}
                  </h2>

                  {/* Price */}
                  <div
                    className={`flex items-end ${
                      plan.per_device_security_deposit > 0
                        ? "justify-between"
                        : "justify-center"
                    }`}
                  >
                    <div
                      className={`flex flex-col ${
                        plan.per_device_security_deposit > 0
                          ? ""
                          : "items-center"
                      }`}
                    >
                      <div className="text-gray-500 text-sm">
                        {t("Starts at")}
                      </div>

                      {/* Actual Price (Strikethrough) */}
                      {plan.actual_price && (
                        <div className="flex my-1">
                          <div className="text-gray-400 text-base line-through">
                            {plan.currency} {plan.actual_price}
                          </div>
                          <div className="px-2 py-1 text-xs mx-1 font-semibold rounded-full bg-gradient-to-r from-[#F8C42B] to-[#F6A669] text-white flex items-center">
                            {t("50% Off")}
                          </div>
                        </div>
                      )}

                      {/* Discounted Price */}
                      <div className="text-primaryBlue text-xl font-bold">
                        {plan.currency} {plan.cost}
                      </div>

                      <div className="text-gray-500 text-sm mb-2">
                        {plan.no_of_user
                          ? `${t("Including")} ${plan.no_of_user} ${t("Users")}`
                          : plan.billing_type}
                      </div>
                    </div>

                    {/* Extra monthly fee */}
                    {plan.per_device_security_deposit > 0 && (
                      <div className="gap-2 mb-2">
                        <p className="text-primaryBlue text-xl font-bold">
                          {plan.currency} {plan.per_device_security_deposit}
                        </p>
                        <p className="text-gray-500 text-sm">
                          {t("Security Deposit")}
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-300 my-4"></div>

                  {/* Benefits */}
                  <h3 className="text-sm font-semibold mb-3">
                    {t("Plan Benefits")}
                  </h3>
                  <ul className="space-y-2 mb-3 flex-1">
                    {benefits.map((benefit, idx) => (
                      <li
                        key={idx}
                        className="flex items-center gap-2 text-gray-700 text-sm"
                      >
                        <Image
                          src={require("../../assets/subcriptionCheck.png")}
                          alt="myGINNE logo"
                          width={20}
                          height={20}
                          preview={false}
                        />
                        <span className="w-[240px]">{benefit}</span>{" "}
                      </li>
                    ))}
                  </ul>

                  {/* Footer (pushed to bottom by flex-1 above) */}

                  <button
                    className={`w-full mt-auto py-2 rounded-xl font-semibold transition bg-primaryBlue text-white disabled:opacity-50 `}
                    onClick={() =>
                      user_id
                        ? navigate(routes.dashboard)
                        : navigate(routes.login)
                    }
                  >
                    {t("Get")}
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Pricing;
